//引入接口文档
import req from '@/utils/req.js'

// 检索当前重点字段关联的匹配规则
export function getQueryRuleById(id) {
    return req.get(`/biz/admin/focusFieldConfigDetail/queryRuleById/${id}`)
}

// 新增规则
export function saveRule(params) {
    return req.post("/biz/admin/focusFieldConfig/saveRule", params);
}

// 修改规则
export function updateRule(params) {
    return req.put("/biz/admin/focusFieldConfig/updateRule", params);
}

// 删除重点字段规则
export function deletedRule(ruleId) {
    return req.delete(`/biz/admin/focusFieldConfig/deletedRule/${ruleId}`)
}